
<!-- DESKTOP -->
<div *ngIf="!isMobile" class="tl-cnt-login" [ngClass]="{'ti-login-border' : showBorder, 'ti-cnt-login-withlogo' : pathLogo != ''}">
    <img *ngIf="pathLogo != ''" [src]="pathLogo" class="img-logo">
    <teiasoft-title *ngIf="loginTitle != ''" [title]="loginTitle" [theme]="theme"></teiasoft-title>
    <i *ngIf="showIcon" class="fad fa-sign-in-alt ico-login"></i>
    <span class="span-please">{{courtesyTitle}}</span>
    <form name="loginForm" class="form-login">
        <div class="login-input-cnt">
            <teiasoft-input [type]="'text'" [placeHolder]="'login.placeHolderUser' | translate" (onKeyUp)="onKeyUp($event)" (onInput)="onInputSetUsername($event)" [isRequired]="true" [isMobile]="isMobile"></teiasoft-input>
        </div>
        <div class="login-input-cnt">
            <teiasoft-input [type]="'password'" [placeHolder]="'login.placeHolderPwd' | translate" (onKeyUp)="onKeyUp($event)" (onInput)="onInputSetPwd($event)" [isRequired]="true"  [isMobile]="isMobile"></teiasoft-input>
        </div>
    </form>
    <div style="margin-top:3vh">
        <teiasoft-button (onClick)="loginClick()" [text]="'login.title' | translate" [disabled]="loginForm.status === 'INVALID'"  [theme]="theme" style="width:100%" [isMobile]="isMobile"></teiasoft-button>
    </div>
    <div class="cnt-pwd-recovery">
        <span class="span-app-version">{{appVersion}}</span>
        <teiasoft-link *ngIf="showPasswordRecovery" [text]="'login.forgotPwd' | translate" (onClick)="linkClick()"></teiasoft-link>
    </div>
   <!--  <div class="cnt-app-version">
        <span class="span-app-version">{{appVersion}}</span>
    </div> -->
</div>


<!-- MOBILE -->
<div *ngIf="isMobile" class="ti-cnt-login-mobile" [ngClass]="{'ti-login-border' : showBorder, 'ti-cnt-login-withlogo-mobile' : pathLogo != ''}" > <!-- [style.width.px]="mobileW" -->
    <img *ngIf="pathLogo != ''" [src]="pathLogo" class="img-logo-mobile">
    <teiasoft-title [title]="loginTitle" [theme]="theme" [isMobile]="isMobile"></teiasoft-title>
    <i *ngIf="showIcon" class="fad fa-sign-in-alt ico-login-mobile"></i>
    <span class="span-please-mobile">{{courtesyTitle}}</span>
    <form name="loginForm" class="form-login">
        <div class="login-input-cnt">
            <teiasoft-input [type]="'text'" [placeHolder]="'login.placeHolderUser' | translate" (onInput)="onInputSetUsername($event)" [isRequired]="true" [isMobile]="isMobile"></teiasoft-input>
        </div>
        <div class="login-input-cnt">
            <teiasoft-input [type]="'password'" [placeHolder]="'login.placeHolderPwd'" (onInput)="onInputSetPwd($event)" [isRequired]="true"  [isMobile]="isMobile"></teiasoft-input>
        </div>
    </form>
    <div style="margin-top:3vh">
        <teiasoft-button (onClick)="loginClick()" [text]="'login.title' | translate" [disabled]="loginForm.status === 'INVALID'"  [theme]="theme" style="width:100%" [isMobile]="isMobile"></teiasoft-button>
    </div>
    <div class="cnt-pwd-recovery">
        <span class="span-app-version">{{appVersion}}</span>
        <teiasoft-link *ngIf="showPasswordRecovery" [text]="'login.forgotPwd' | translate" (onClick)="linkClick()"></teiasoft-link>
    </div>
    <!-- <div class="cnt-app-version">
        <span class="span-app-version">{{appVersion}}</span>
    </div> -->
</div>
